import React from 'react';
import { connect } from 'react-redux';
import { find as _find } from 'lodash';

import * as CmsEditableElements from 'components/cms/editableElements';
import * as CmsElements from 'components/cms/elements';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';

class CmsElement extends React.Component {
  getComponentName = (componentType) => {
    if (!componentType || typeof componentType !== 'string') {
      return null;
    }
    const componentName = ('CmsElement_' + componentType.toLowerCase()).replace(/_([a-z])/g, (g) => {
      return g[1].toUpperCase();
    });
    return componentName;
  };

  getComponentByName = (name) => {
    if (!name) return null;

    const { editMode } = this.props;

    if (!editMode && CmsElements[name] !== undefined) {
      return CmsElements[name];
    }

    if (CmsEditableElements[name] !== undefined) {
      return CmsEditableElements[name];
    }

    return null;
  };

  render() {
    const {
      appIntl,
      type,
      children,
      index,
      editMode,
      effectsEnabled,
      textSubstitute,
      dynamicElementContent,
      dynamic_element_content: underscoreDynamicElementContent,
      addElement,
      removeElement,
      reorderElements,
      showElementSettings,
      canvasContainerRef,
      layout,
      scale
    } = this.props;

    const componentName = this.getComponentName(type);
    const RenderComponent = this.getComponentByName(componentName);

    // Fallback if type is missing or the component is not registered
    if (!RenderComponent) {
      console.warn(`CmsElement: Component for type "${type}" could not be found.`);
      return null;
    }

    // check if we have any children for this element
    // if it's a dynamic element, children are stored in an extra prop -> dynamicElementContent
    // dynamicElementContent contains information for multiple languages, but we only need one
    let parseChildren = children;
    if (type === 'dynamic_element') {
      const dynamicElementLangContent = _find(dynamicElementContent || underscoreDynamicElementContent, [
        'language',
        appIntl.displayIntlForm,
      ]);
      parseChildren = (dynamicElementLangContent && dynamicElementLangContent.content) || null;
    }

    return (
      <RenderComponent {...this.props}>
        {parseChildren && parseChildren.length
          ? parseChildren.map((child, i) => {
            if (!child) return null;

            const elementIndex = index + '.' + i;
            const editModeProp = type === 'dynamic_element' ? false : editMode;
            return (
              <CmsElement
                {...this.props}
                key={child.id || `element-${elementIndex}`}
                appIntl={appIntl}
                index={elementIndex}
                type={child.type}
                editMode={editModeProp}
                effectsEnabled={effectsEnabled}
                textSubstitute={textSubstitute}
                params={child.params ? [...child.params] : []}
                addElement={addElement}
                removeElement={removeElement}
                reorderElements={reorderElements}
                showElementSettings={showElementSettings}
                canvasContainerRef={canvasContainerRef}
                layout={layout}
                scale={scale}
              >
                {child.children}
              </CmsElement>
            );
          })
          : null}
      </RenderComponent>
    );
  }
}

CmsElement.defaultProps = {
  type: '',
  editMode: false,
  effectsEnabled: true,
  addElement: () => {},
  reorderElements: () => {},
  textSubstitute: null,
};

const mapStateToProps = (state) => {
  return {
    user: state.login.user,
  };
};

export default withRouter(legacyInjectIntl(connect(mapStateToProps)(CmsElement)));
